module.exports = __webpack_public_path__ + "static/logo-sig-77995880c870e2a7d0b2a94e6d01b565.svg";